import React from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import { Link } from "react-router-dom";
import Podcast from "../components/Podcast.jsx";
import { Helmet } from "react-helmet";
import SEO from "../components/SEO.jsx";
const PodcastPage = () => {
    return (
        <>

<SEO 
      page="podcasts"
      customMeta={{
       
        title: "Podcasts - Shape Shifting Mastery",
    description: "Listen to expert insights, transformation stories, and practical tips for your fitness journey. Weekly episodes on body transformation and personal development.",
    keywords: "fitness podcasts, transformation stories, expert interviews, fitness tips, wellness podcasts",
    ogTitle: "Podcasts - Shape Shifting Mastery",
    ogDescription: "Listen to expert insights, transformation stories, and practical tips for your fitness journey. Weekly episodes on body transformation and personal development."
      }}
    />
             {/* <Helmet>
  <title>Podcasts - Shape Shifting Mastery </title> 
  <meta name="description" content='Read more about our Podcasts' />
  <meta name="keywords" content='blogData.seo_keywords' />

</Helmet>  */}
            <Podcast />
        </>
    );
};

export default PodcastPage;
